export const PROJECT_VERSION = '0.3.50';
